<template>
  <div class="pa-4" style="width: 100%; min-height: 80vh;">
    <v-card class="elevation-1">
      <v-card-title class="headline primary white--text py-3 px-4 d-flex align-center">
        <v-icon left dark>mdi-bookshelf</v-icon>
        Invoice Report
        <v-spacer></v-spacer>
        <v-btn icon dark @click="loadTransactions" :loading="isLoading">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-4">
        <!-- Search Filter -->
        <v-row dense class="mb-3 align-center">
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="searchQuery"
              prepend-inner-icon="mdi-magnify"
              label="Search by Invoice, Customer or Locator"
              dense
              outlined
              clearable
              hide-details
            ></v-text-field>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="auto" class="caption grey--text text--darken-1">
            Total Records: <strong>{{ filteredInvoices.length }}</strong>
          </v-col>
        </v-row>

        <!-- Loading State -->
        <div v-if="isLoading" class="text-center py-8">
          <v-progress-circular indeterminate color="primary" size="48"></v-progress-circular>
          <div class="mt-2 subtitle-2 grey--text">Loading invoice records...</div>
        </div>

        <!-- Empty State -->
        <v-alert v-else-if="filteredInvoices.length === 0" type="info" outlined dense class="my-4">
          No invoice records found.
        </v-alert>

        <!-- Table -->
        <v-simple-table v-else fixed-header height="650px" class="elevation-1">
          <template v-slot:default>
            <thead>
              <tr class="grey lighten-3">
                <th class="text-left font-weight-bold">Invoice #</th>
                <th class="text-left font-weight-bold">Customer ID</th>
                <th class="text-left font-weight-bold">Customer Name</th>
                <th class="text-left font-weight-bold">Contact No</th>
                <th class="text-left font-weight-bold">Invoice Date</th>
                <th class="text-left font-weight-bold">Locator</th>
                <th class="text-left font-weight-bold">Vend Loc</th>
                <th class="text-right font-weight-bold">Cost</th>
                <th class="text-right font-weight-bold">Total Gross</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in filteredInvoices" :key="item.id" class="hover-row">
                <td class="primary--text font-weight-bold">#{{ item.id }}</td>
                <td>{{ (item.customer && item.customer.id) || '-' }}</td>
                <td class="font-weight-medium">{{ (item.customer && item.customer.name) || '-' }}</td>
                <td>{{ (item.customer && (item.customer.contactNumber || item.customer.mobileNumber)) || '-' }}</td>
                <td>{{ formatDate(item.createdAt) }}</td>
                <td><v-chip x-small class="font-weight-bold">{{ item.locator || '-' }}</v-chip></td>
                <td>{{ item.vendLoc || '-' }}</td>
                <td class="text-right">£{{ formatCurrency(item.cost) }}</td>
                <td class="text-right font-weight-bold">£{{ formatCurrency(item.total) }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { ledgerService } from './../../services/'
import moment from 'moment'

export default {
  name: 'InvoiceReport',
  data: () => ({
    isLoading: true,
    invoiceReportData: [],
    searchQuery: '',
  }),

  computed: {
    filteredInvoices () {
      if (!this.invoiceReportData || !Array.isArray(this.invoiceReportData)) return []
      if (!this.searchQuery || !this.searchQuery.trim()) return this.invoiceReportData

      const q = this.searchQuery.trim().toLowerCase()
      return this.invoiceReportData.filter(item => {
        const id = String(item.id || '')
        const custName = (item.customer && item.customer.name ? item.customer.name : '').toLowerCase()
        const custId = String((item.customer && item.customer.id) || '')
        const loc = (item.locator || '').toLowerCase()
        const vend = (item.vendLoc || '').toLowerCase()
        return id.includes(q) || custName.includes(q) || custId.includes(q) || loc.includes(q) || vend.includes(q)
      })
    }
  },

  methods: {
    loadTransactions () {
      this.isLoading = true
      ledgerService.getInvoiceReport()
        .then(invoiceReport => {
          this.invoiceReportData = invoiceReport || []
          this.isLoading = false
        })
        .catch(err => {
          console.error('Failed to load invoice report:', err)
          this.invoiceReportData = []
          this.isLoading = false
        })
    },

    formatDate (dateStr) {
      if (!dateStr) return '-'
      return moment(dateStr).format('YYYY-MM-DD')
    },

    formatCurrency (val) {
      if (val == null || isNaN(val)) return '0.00'
      return parseFloat(val).toFixed(2)
    }
  },

  mounted () {
    this.loadTransactions()
  }
}
</script>

<style scoped>
.hover-row:hover {
  background-color: #f0f7ff !important;
}
</style>